var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No menu items yet...\" grid-title=\"Contract Menu Items\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.menuItems\" create-method=\"addMenuItem\" update-method=\"\" delete-method=\"deleteMenuItem\" add-toggle=\"vm.sideTab.menuItems\" options-list=\"vm.foodOptions\" fields=\"{printOnHandoutMenu: {input: 'checkbox', header: 'Print on Menu', order: 10, width: 5, type: 'checkbox'}, name: {input: 'text', header: 'Menu Item', order: 15, width: 20, type: 'string'}, description: {input: 'textarea', header: 'Description', order: 20, width: 45, type: 'string'}, quantity: {input: 'text', header: 'Quantity', order: 30, width: 10, type: 'string'}, price: {viewDisplayAs: 'currency', input: 'text', header: 'Price 2', order: 40, width: 10, type: 'string'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/food.jade
// module id = 272
// module chunks = 0